import {
  CrudFilters,
  IResourceComponentsProps,
  useGetIdentity,
  useNavigation,
} from '@pankod/refine-core';
import {
  Button,
  CreateButton,
  DateField,
  DeleteButton,
  EditButton,
  EmailField,
  FilterDropdown,
  FilterDropdownProps,
  getDefaultSortOrder,
  Input,
  List,
  NumberField,
  Select,
  ShowButton,
  Space,
  Table,
  TagField,
  TextField,
  Tooltip,
  useTable,
} from '@pankod/refine-antd';

import { SolutionOutlined, FileAddOutlined } from '@ant-design/icons';
import { IUser } from 'interfaces';
import { UserStatus } from '../../enums/user.status';
import React, { CSSProperties, useContext } from 'react';
import { Role } from '../../enums/role';
import { ModalAgentList } from 'components/users/modalAgentList';
import { UserContext } from 'UserProvider';

export const UserList: React.FC<IResourceComponentsProps> = () => {
  const { show } = useNavigation();
  const [open, setOpen] = React.useState<boolean>(false);
  const [selectedUuid, setSelectedUuid] = React.useState<number | null>(null);
  const userContext = useContext(UserContext);
  const me = userContext ? userContext.user : null;

  // const { data: me } = useGetIdentity<IUser>();
  const initialFilter: CrudFilters = [];

  const { tableProps, sorter } = useTable<IUser>({
    initialSorter: [
      {
        field: 'createdAt',
        order: 'desc',
      },
    ],
    initialFilter,
  });
  return (
    <List
      headerProps={{
        extra: (
          <CreateButton
            style={{ marginTop: 10 }}
            type={'dashed'}
            children="Создать пользователя"
          />
        ),
      }}
    >
      {open && (
        <ModalAgentList
          uuid={selectedUuid}
          open={open}
          cancel={() => setOpen(false)}
        />
      )}
      <Table {...tableProps} rowKey="uuid">
        <Table.Column
          dataIndex="uuid"
          key="uuid"
          title="№ ЛС"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder('phone', sorter)}
          sorter
        />

        <Table.Column
          dataIndex="email"
          key="email"
          title="Email"
          render={(value) => (
            <EmailField style={{ whiteSpace: 'nowrap' }} value={value} />
          )}
          defaultSortOrder={getDefaultSortOrder('email', sorter)}
          sorter
          filterDropdown={(props: FilterDropdownProps) => (
            <FilterDropdown {...props}>
              <Input />
            </FilterDropdown>
          )}
        />
        <Table.Column
          dataIndex="lastName"
          key="lastName"
          title="Фамилия"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder('lastName', sorter)}
          sorter
          filterDropdown={(props: FilterDropdownProps) => (
            <FilterDropdown {...props}>
              <Input />
            </FilterDropdown>
          )}
        />
        <Table.Column
          dataIndex="firstName"
          key="firstName"
          title="Имя"
          render={(value) => (
            <TextField style={{ wordBreak: 'normal' }} value={value} />
          )}
          defaultSortOrder={getDefaultSortOrder('firstName', sorter)}
          sorter
        />

        <Table.Column
          dataIndex="role"
          key="role"
          title="Роль"
          render={(value) => <TagField value={value} />}
          defaultSortOrder={getDefaultSortOrder('role', sorter)}
          sorter
          filterDropdown={(props) => (
            <FilterDropdown {...props}>
              <Select
                style={{ minWidth: 200 }}
                mode="multiple"
                placeholder="Выберите роли"
                options={Object.values(Role).map((status) => ({
                  label: status,
                  value: status,
                }))}
              />
            </FilterDropdown>
          )}
        />
        <Table.Column
          dataIndex="createdAt"
          key="createdAt"
          title="Создан"
          render={(value) => (
            <DateField value={value} format={'DD.MM.YYYY, HH:mm'} />
          )}
          defaultSortOrder={getDefaultSortOrder('createdAt', sorter)}
          sorter
        />
        <Table.Column
          key="action"
          title="Функции"
          render={(_, value: any) => (
            <>
              <DeleteButton recordItemId={value.uuid} hideText size="small" />
            </>
          )}
        />
      </Table>
    </List>
  );
};
